import { UpdateCallback } from '@hb/shared'
import { deleteDoc, doc } from 'firebase/firestore'
import { ASSESSMENTS_REF } from '../../backend/db/collections'

export const deleteAssessment = (id: string): Promise<UpdateCallback> =>
  deleteDoc(doc(ASSESSMENTS_REF, id))
    .then(() => ({ success: 'ok' }))
    .catch(() => ({ error: 'error' }))
